import { Heading as HeadingBase, HeadingProps } from '@wix/design-system';
import { st, classes } from './Heading.st.css.js';
import React from 'react';

export function Heading(props: HeadingProps) {
  const { appearance, className, ...rest } = props;

  return (
    <HeadingBase
      {...rest}
      appearance={appearance}
      className={st(classes.root, {
        appearanceH2: appearance === 'H2',
      })}
    />
  );
}
